module.exports = __webpack_public_path__ + "img/SLOPE.69a2719b.jpg";